import { Report2 } from "../../components/report";

export default function ReportData2() {
  return <Report2 />;
}
